const AdmeetRoutes = {
  getAllAdMeets: "/admin/getallblogs",
  createAdMeet: "/blog/blog",
  updateAdMeet: "/blog/updateblogs",
  getAdMeetRegistration: "/admeet/getRegistrations",
  approveBlog: "/admin/approveBlog"
}

export default AdmeetRoutes;